<div class="uls self-declaration-page ul-card" [class.embedded]="embedded()">
  <h1 class="page-title">{{ 'selfDeclaration.title' | translate }}</h1>
  <p class="intro-text">{{ 'selfDeclaration.intro' | translate }}</p>

  @if (revision(); as revision) {
    <section class="info-panel" aria-labelledby="product-information-title">
      <h2 id="product-information-title" class="section-title">
        {{ 'selfDeclaration.productInformationTitle' | translate }}
      </h2>
      <dl class="info-grid">
        <dt>{{ 'model.manufacturer.singular' | translate }}</dt>
        <dd>{{ revision.product.manufacturer.brandName || ('general.no_data' | translate) }}</dd>
        <dt>{{ 'model.product.properties.name' | translate }}</dt>
        <dd>{{ revision.product.name || ('general.no_data' | translate) }}</dd>
        <dt>{{ 'model.productRevision.singular' | translate }}</dt>
        <dd>{{ revision.revision || ('general.no_data' | translate) }}</dd>

        <dt>{{ 'model.product.properties.description' | translate }}</dt>
        <dd>{{ revision.product.description || ('general.no_data' | translate) }}</dd>
      </dl>
    </section>

    <section class="info-panel" aria-labelledby="analysis-title">
      <h2 id="analysis-title" class="section-title">
        {{ 'selfDeclaration.requirementAssessmentStatusTitle' | translate }}
      </h2>
      @if (isLoading()) {
        <p>{{ 'selfDeclaration.loadingAssessmentSummary' | translate }}</p>
      } @else if (assessmentSummary(); as assessmentSummary) {
        <dl class="info-grid compact">
          <dt>{{ 'selfDeclaration.counts.pass' | translate }}</dt>
          <dd>{{ assessmentSummary.passedCount ?? 0 }}</dd>

          <dt>{{ 'selfDeclaration.counts.failed' | translate }}</dt>
          <dd>{{ assessmentSummary.failedCount ?? 0 }}</dd>

          <dt>{{ 'selfDeclaration.counts.notApplicable' | translate }}</dt>
          <dd>{{ assessmentSummary.notApplicableCount ?? 0 }}</dd>

          <dt>{{ 'selfDeclaration.counts.notAssessed' | translate }}</dt>
          <dd>{{ assessmentSummary.notAssessedCount ?? 0 }}</dd>
        </dl>

        @if ((assessmentSummary.notAssessedRequirements?.length ?? 0) > 0) {
          <h3>{{ 'selfDeclaration.notAssessedRequirementsTitle' | translate }}</h3>
          <ul>
            @for (item of assessmentSummary.notAssessedRequirements; track item.id) {
              <li>
                <a [routerLink]="['..']" [queryParams]="{ requirementId: item.id }">
                  {{
                    item.name ||
                      ('selfDeclaration.requirementFallback' | translate: { id: item.id })
                  }}
                </a>
              </li>
            }
          </ul>
        }
      } @else {
        <p>{{ 'selfDeclaration.noAssessmentSummary' | translate }}</p>
      }
    </section>

    <section class="info-panel" aria-labelledby="declaration-title">
      <h2 id="declaration-title" class="section-title">
        {{ 'selfDeclaration.declarationStatementTitle' | translate }}
      </h2>
      <section>
        <h4>{{ 'selfDeclaration.assessedStandardsTitle' | translate }}</h4>
        <!-- due to style white-space: pre-line -->
        <!-- prettier-ignore -->
        <p class="standards">{{ assessmentSummary()?.standardName || ('general.no_data' | translate) }}</p>
      </section>
      <section>
        <p>{{ 'selfDeclaration.declarationStatementLine1' | translate }}</p>
        <p>{{ 'selfDeclaration.declarationStatementLine2' | translate }}</p>
      </section>
      <mat-checkbox [checked]="agreementChecked()" (change)="onAgreementChange($event)">
        {{ 'selfDeclaration.agreementLabel' | translate }}
      </mat-checkbox>
    </section>

    <div class="button-bar">
      <button comp-button="tertiary" type="button" (click)="onCancel()">
        {{ 'general.cancel' | translate }}
      </button>
      <button comp-button type="button" [disabled]="!canSubmit()" (click)="onSubmitDeclaration()">
        {{
          (isSubmitting()
            ? 'selfDeclaration.actions.submitting'
            : 'selfDeclaration.actions.submitDeclaration'
          ) | translate
        }}
      </button>
    </div>
  } @else {
    <p>{{ 'selfDeclaration.unableToLoadRevisionDetails' | translate }}</p>
  }

  @if (errorMessage()) {
    <p class="feedback error" role="alert">{{ errorMessage() }}</p>
  }
</div>
